(function(){
  var sda=CSS.supports&&CSS.supports('animation-timeline:view()');

  // progress (JS fallback when scroll-driven animations are unsupported)
  if(!sda){
    var prog=document.getElementById('prog');
    function onScroll(){var h=document.documentElement.scrollHeight-window.innerHeight;prog.style.width=(h>0?(window.scrollY/h)*100:0)+'%';}
    addEventListener('scroll',onScroll,{passive:true});onScroll();
  }

  // reveal fallback
  if(!sda){
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
      },{rootMargin:'0px 0px -8% 0px',threshold:.06});
      document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
    } else { document.querySelectorAll('.rv').forEach(function(el){el.classList.add('in');}); }
  }

  // partners strip — transform marquee: timer-driven, drag/swipe with pointer events, seamless loop
  var ps=document.getElementById('pstrip'),pt=document.getElementById('ptrack');
  if(ps&&pt){
    pt.innerHTML+=pt.innerHTML;
    var reduce=!!(window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches);
    var x=0,half=0,down=false,sx=0,sox=0,hold=0,last=0,moved=0;
    function measure(){half=pt.scrollWidth/2;}
    measure();addEventListener('resize',measure,{passive:true});addEventListener('load',measure);
    function paint(){pt.style.transform='translate3d('+x+'px,0,0)';}
    function tick(t){
      if(!last)last=t;var dt=Math.min(t-last,50);last=t;
      if(!half)measure();
      if(!reduce&&!down&&Date.now()>hold&&!document.hidden)x-=dt*0.04;
      if(half){if(x<=-half)x+=half;if(x>0)x-=half;}
      paint();requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    ps.addEventListener('pointerdown',function(e){down=true;sx=e.clientX;sox=x;moved=0;try{ps.setPointerCapture(e.pointerId);}catch(err){}});
    ps.addEventListener('pointermove',function(e){if(!down)return;var d=e.clientX-sx;moved=Math.max(moved,Math.abs(d));x=sox+d;if(half){if(x<=-half)x+=half;if(x>0)x-=half;}paint();});
    function up(){if(down){down=false;hold=Date.now()+2000;}}
    ps.addEventListener('pointerup',up);ps.addEventListener('pointercancel',up);ps.addEventListener('lostpointercapture',up);
    ps.addEventListener('dragstart',function(e){e.preventDefault();});
  }

  // interactive selector (length)
  var fl=document.querySelector('[data-flame]');
  if(fl){
    var tabs=fl.querySelectorAll('[data-f]'),panels=fl.querySelectorAll('[data-p]'),pics=fl.querySelectorAll('[data-pic]'),caps=fl.querySelectorAll('[data-cap]');
    tabs.forEach(function(t){t.addEventListener('click',function(){
      var k=t.getAttribute('data-f');
      tabs.forEach(function(b){var on=b===t;b.classList.toggle('on',on);b.setAttribute('aria-selected',on?'true':'false');});
      panels.forEach(function(pn){var on=pn.getAttribute('data-p')===k;pn.hidden=!on;if(on){pn.style.animation='none';void pn.offsetWidth;pn.style.animation='';}});
      pics.forEach(function(im){im.classList.toggle('on',im.getAttribute('data-pic')===k);});
      caps.forEach(function(c){c.classList.toggle('on',c.getAttribute('data-cap')===k);});
    });});
  }

  // carousels — swipe + arrows (click & touch) + dots + keys
  document.querySelectorAll('[data-car]').forEach(function(root){
    var track=root.querySelector('[data-track]'),
        dots=root.querySelector('[data-dots]'),
        prev=root.querySelector('[data-prev]'),
        next=root.querySelector('[data-next]'),
        items=Array.prototype.slice.call(track.children);
    if(!items.length) return;
    items.forEach(function(el,i){
      el.style.setProperty('--i',i);
      var d=document.createElement('i');
      d.addEventListener('click',function(){go(i);});
      dots.appendChild(d);
    });
    function gap(){return parseFloat(getComputedStyle(track).columnGap)||12;}
    function step(){return items[0].getBoundingClientRect().width+gap();}
    function idx(){return Math.round(track.scrollLeft/step());}
    function go(i){i=Math.max(0,Math.min(items.length-1,i));track.scrollTo({left:i*step(),behavior:'smooth'});}
    function sync(){
      var i=idx(),max=track.scrollWidth-track.clientWidth-2;
      Array.prototype.forEach.call(dots.children,function(d,n){d.classList.toggle('on',n===i);});
      prev.disabled=track.scrollLeft<=2;
      next.disabled=track.scrollLeft>=max;
    }
    function bind(btn,dir){
      var fired=0;
      function act(e){
        if(e.type==='touchend'){fired=Date.now();}
        else if(Date.now()-fired<600){return;}
        e.preventDefault();go(idx()+dir);
      }
      btn.addEventListener('click',act);
      btn.addEventListener('touchend',act,{passive:false});
    }
    bind(prev,-1);bind(next,1);
    var t;track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(sync,70);},{passive:true});
    addEventListener('resize',sync,{passive:true});
    track.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){e.preventDefault();go(idx()+1);}
      if(e.key==='ArrowLeft'){e.preventDefault();go(idx()-1);}
    });
    sync();
  });
})();